import { Dependencies } from "@planzone/core";
import { Planzone, Identifiable } from "@planzone/dto";
import { OidcLogin } from "./oidcAuthenticator";

function createSession(
  getCurrentPlanzone: () => Identifiable<Planzone>,
): Dependencies["session"] {
  return {
    start: (data) => {
      sessionStorage.setItem("session", JSON.stringify(data));

      return Promise.resolve(data);
    },
    retrieve: () => {
      const data = sessionStorage.getItem("session");

      return data ? Promise.resolve(JSON.parse(data)) : Promise.reject();
    },
    destroy: () => {
      sessionStorage.removeItem("session");

      return new OidcLogin(getCurrentPlanzone().uuid).logout();
    },
    reload: () => {
      return new OidcLogin(getCurrentPlanzone().uuid)
        .renewToken()
        .then((res) => (res ? res : Promise.reject()))
        .then(({ access_token, refresh_token, expires_in }) => ({
          accessToken: `${access_token}`,
          expiresAt: expires_in || 0,
          refreshToken: `${refresh_token}`,
        }));
    },
  };
}

export { createSession };
